import { EMAIl_REGEX, PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, STRING_MAX_LENGTH } from "@/User/Constants/validator";
import { object, ref, string } from "yup";

export const AlphabetRegex = /\p{L}/u;
export const NumericRegex = /\p{N}/u;

const emailValidationScheme = {
    email: string()
        .required('メールアドレスを入力してください。')
        .max(STRING_MAX_LENGTH, `メールアドレスは${STRING_MAX_LENGTH}桁数を超えました。`)
        .email('メールアドレスが正しくありません。')
        .matches(EMAIl_REGEX, 'メールアドレスが正しくありません。'),
};

export const emailValidationRules = object(emailValidationScheme);

const passwordValidationScheme = {
    password: string()
        .required('パスワードを入力してください。')
        .min(PASSWORD_MIN_LENGTH, `${PASSWORD_MIN_LENGTH}文字以上入力してください。`)
        .max(PASSWORD_MAX_LENGTH, `パスワードは${PASSWORD_MAX_LENGTH}桁数を超えました。`)
        .matches(AlphabetRegex, `英数字${PASSWORD_MIN_LENGTH}文字以上を組み合わせてパスワードを作成してください。`)
        .matches(NumericRegex, `英数字${PASSWORD_MIN_LENGTH}文字以上を組み合わせてパスワードを作成してください。`),
    password_confirm: string()
        .oneOf([ref('password')], 'パスワードが等しくありません。'),
};

export const passwordValidationRules = object(passwordValidationScheme);
